import Vue from 'vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import axios from './backend/vue-axios'
import usefull from './library/usefull.js'
import usefullAdmin from './library/usefullAdmin.js'
import VueAnalytics from 'vue-analytics'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';


Sentry.init({
    dsn: 'https://bbc09fadd58e455ab1f70c2c4d9860f0@sentry.io/1855161',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

require('./library/formValidationRules.js')


// Ajout des layouts
import Default from './layouts/default'
import Security from './layouts/security'
import Admin from './layouts/admin'
import listDancer from './layouts/listDancer'

Vue.component('default-layout', Default)
Vue.component('security-layout', Security)
Vue.component('admin-layout', Admin)
Vue.component('list-dancer-layout', listDancer)

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === "production"

Vue.use(usefull)
Vue.use(usefullAdmin)
Vue.use(VueAnalytics, {
    id: 'UA-141814633-2',
    router,
    debug: {
        enabled: false,
        sendHitTask: isProd
    }
})
import App from './App.vue'

new Vue({
    router,
    store,
    axios,
    render: h => h(App)
}).$mount('#app')
